/**
 * The customer confirms who they are. Nothing here hints at the expected values — that would
 * narrow them for anyone else holding the link too.
 */

import { Input, Label } from '@design-system';

import { PrefillDateField } from '@/features/invite-client';
import { fromDateOnlyString, toDateOnlyString } from '@/shared/lib/utils';

interface AgentEnteredVerifyStepProps {
  email: string;
  birthDate: string;
  disabled?: boolean;
  onEmailChange: (value: string) => void;
  onBirthDateChange: (value: string) => void;
}

export function AgentEnteredVerifyStep({
  email,
  birthDate,
  disabled,
  onEmailChange,
  onBirthDateChange,
}: AgentEnteredVerifyStepProps) {
  return (
    <div className="space-y-5">
      <div className="flex flex-col gap-2">
        <Label htmlFor="agent-entered-consent-email">Your email address</Label>
        <Input
          id="agent-entered-consent-email"
          type="email"
          autoComplete="email"
          placeholder="you@example.com"
          disabled={disabled}
          value={email}
          onChange={event => onEmailChange(event.target.value)}
        />
      </div>

      <PrefillDateField
        id="agent-entered-consent-birth-date"
        label="Your date of birth"
        value={fromDateOnlyString(birthDate)}
        onChange={date => onBirthDateChange(toDateOnlyString(date))}
      />
    </div>
  );
}
